var _dec, _class, _Cell;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { omitProps, callRenderProp } from '@instructure/ui-react-utils';
import { View } from '@instructure/ui-view';
import { withStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
import TableContext from "../TableContext.js";
/**
---
parent: Table
id: Table.Cell
---
**/
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let Cell = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Cell = class Cell extends Component {
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      children = _this$props3.children,
      styles = _this$props3.styles,
      header = _this$props3.header;
    const isStacked = this.context.isStacked;
    return _jsxs(View, {
      ...View.omitViewProps(omitProps(this.props, Cell.allowedProps), Cell),
      as: isStacked ? 'div' : 'td',
      css: styles === null || styles === void 0 ? void 0 : styles.cell,
      role: isStacked ? 'cell' : void 0,
      children: [header && callRenderProp(header), header && ': ', callRenderProp(children)]
    });
  }
}, _Cell.displayName = "Cell", _Cell.componentId = 'Table.Cell', _Cell.contextType = TableContext, _Cell.allowedProps = allowedProps, _Cell.defaultProps = {
  textAlign: 'start',
  children: null
}, _Cell)) || _class);
export default Cell;
export { Cell };